import React from 'react';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';

export interface ProSegmentTabOption<T extends string = string> {
  value: T;
  label: React.ReactNode;
}

export interface ProSegmentTabsProps<T extends string = string> {
  value: T;
  onChange: (value: T) => void;
  options: ProSegmentTabOption<T>[];
  className?: string;
  scrollable?: boolean;
}

/**
 * Styled IonSegment wrapper for Pro mobile — drop-in replacement for inline segments.
 * Behavior/values/handlers stay with the parent; this only standardizes presentation.
 */
function ProSegmentTabs<T extends string = string>({
  value,
  onChange,
  options,
  className = '',
  scrollable = false,
}: ProSegmentTabsProps<T>) {
  return (
    <IonSegment
      value={value}
      scrollable={scrollable}
      onIonChange={(e) => {
        const next = e.detail.value;
        if (typeof next === 'string') onChange(next as T);
      }}
      className={`pro-segment-tabs px-4 ${className}`.trim()}
    >
      {options.map((opt) => (
        <IonSegmentButton key={opt.value} value={opt.value}>
          <IonLabel>{opt.label}</IonLabel>
        </IonSegmentButton>
      ))}
    </IonSegment>
  );
}

export default ProSegmentTabs;
